module.exports = __webpack_public_path__ + "static/img/NPS-wayside-exhibits01.5655e19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/williamsons/NPS-wayside-exhibits01.jpg
// module id = 988
// module chunks = 0